import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {HttpService} from '@tisa-group/cdk';

import {TISA_UMPIRE_TOKEN, TISA_UMPIRE_URL} from './tisa-umpire.providers';
import {LOCAL_STORAGE} from '@ng-web-apis/common';

@Injectable()
export class TisaUmpireHttpService extends HttpService {
  constructor(
    @Inject(TISA_UMPIRE_URL) readonly api: string,
    @Inject(TISA_UMPIRE_TOKEN) readonly token: (...args: any[]) => string,
    @Inject(LOCAL_STORAGE) readonly localStorage: Storage,
    readonly http: HttpClient,
  ) {
    super();
  }
}
